<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-cow"></i>Selecione o animal</p>
    <v-autocomplete
      class="form-panel__field form-panel__field--wide"
      :items="computedAnimals"
      item-text="name_code"
      item-value="id"
      outlined
      dense
      label="Selecione o Animal"
      v-model="filter.animal"
      return-object
      no-data-text="Nenhum Resultado"
      @update:search-input="searchAnimal"
      clearable
      :key="keyInput"
    ></v-autocomplete>

    <div class="form-panel__actions">
      <v-btn 
        class="success" 
        @click="addAnimal"
        :disabled="!filter.animal"
      >
        <i class="mdi mdi-plus pr-1"></i>
        Adicionar Animal
      </v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name:"ReportFilters",
  props:{
    creators:Array
  },
  data() {
    return {
      filter:{},
      animals:[],
      keyInput:0
    }
  },
  computed: {
    computedAnimals: {
      get() {
        return this.animals.map(e => ({
          ...e,
          name_code:e.code + " - " + e.register + " - " + e.name
        }));
      },
      set(newValue) {
        if(newValue) {
          this.animals = newValue;
        } 
      }
    } 
  },
  methods: {
    ...mapActions("animals", ["actionSearchAnimalsGeneral"]),
    ...mapActions("report_ril", ["actionCleanResults"]),
    async searchAnimal(data) {
      if(data && data.length > 2) {
       this.computedAnimals = await this.actionSearchAnimalsGeneral({register:data});
      }
    },
    addAnimal() {
      this.$emit("add-animal", this.filter.animal);
    }
  },
  watch: {
    animals(val) {
      if(!val.length && this.filter.animal !== undefined) {
        this.computedAnimals = [this.filter.animal]
      }
    },
    // limpar o animal limpa a lista de partos (a consulta seguinte não mostra a anterior)
    "filter.animal": {
      handler(val) {
        if(!val) {
          this.actionCleanResults();
        }
      }
    }
  },
  async mounted() {
    const {animal} = this.$route.params;
    if(animal) {
      await this.searchAnimal(animal.name);
      this.filter.animal = this.computedAnimals[0];
      this.addAnimal();
      this.keyInput = this.keyInput + 1;
    }
  }
}
</script>